import { render, staticRenderFns } from "./NavigationWidget.html?vue&type=template&id=58ecb907&"
import script from "./NavigationWidget.vue?vue&type=script&lang=ts&"
export * from "./NavigationWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports